// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"ca4dee90","171":"377b97ed","432":"adc49739","477":"3f54b1a9","653":"3dd87194","845":"7434a8f4"}[chunkId] + ".chunk.js";
};